// 垂直对齐方式
export const VerticalAlign = {
    TOP: 'flex-start',
    CENTER: 'center',
    BOTTOM: 'flex-end',
};

// todo: 把const换成enum
export enum EVerticalAlign {
    TOP = 'flex-start',
    CENTER = 'center',
    BOTTOM = 'flex-end',
}

// 水平对齐方式
export const HorizontalAlign = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
    JUSTIFY: 'justify',
    DISTRIBUTE: 'distribute',
};

export const AutoFitType = {
    NO_AUTO_FIT: 'noAutofit',           // 不自动调整
    FONT_AUTO_FIT: 'normAutofit',       // 溢出时缩排文字
    SHAPE_AUTO_FIT: 'spAutoFit',        // 根据文字调整形状大小
};
export type AutoFitType = typeof AutoFitType[keyof typeof AutoFitType];

export const WrapType = {
    NO_WRAP: 'pre',
    WRAP: 'pre-wrap',
    MULTI: 'multi',
} as const;

// 仅b端dom版本侧边栏使用
export const FillItemFontStyle = {
    fontFamily: 'PingFangSC-Medium',
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.64)',
};

export const FillType = 'dash';

export const TextPadding = {
    PADDING_LEFT: 'paddingLeft', // 左边距
    PADDING_RIGHT: 'paddingRight', // 右边距
    PADDING_TOP: 'paddingTop', // 上边距
    PADDING_BOTTOM: 'paddingBottom', // 下边距
};
export type TextPadding = typeof TextPadding[keyof typeof TextPadding];

export enum TextDirectionType {
    HORIZONTAL = 'horz',
    VERTICAL = 'eaVert',
    ROTATE_90 = 'vert',
    ROTATE_270 = 'vert270',
    WORD_ART_VERTICAL_RTL = 'wordArtVertRtl',
    WORD_ART_VERTICAL_LTR = 'wordArtVert',

    // 这个选项不是一个有效值，只是用于概括表示两种堆积方式
    WORD_ART_VERTICAL_GENERAL = 'wordArtVertGeneral',
}
